/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Col, Row } from 'react-bootstrap';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';

function CabsPassengerDetails({
  paxList,
  defaultTravellerInfo,
  onPassengerUpdate,
  passengerErrorDict,
}) {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const [passengers, setPassengers] = useState(paxList);
  const TITLE_OPTIONS = [
    { label: formattedMessage('mr'), value: 'Mr' },
    { label: formattedMessage('ms'), value: 'Ms' },
    { label: formattedMessage('mrs'), value: 'Mrs' },
  ];
  const CHILD_TITLE_OPTIONS = [
    { label: formattedMessage('mstr'), value: 'Mstr' },
    { label: formattedMessage('ms'), value: 'Ms' },
  ];
  const handleChange = (event, index) => {
    const { name, value } = event.target;
    const paxList = [...passengers];
    paxList[index][name] = value;
    setPassengers(paxList);
  };
  const handleDropDownChange = (value, name, index) => {
    const updatedValue = value !== null ? value.value : '';
    const paxList = [...passengers];
    paxList[index][name] = updatedValue;
    setPassengers(paxList);
  };
  useEffect(() => {
    if (onPassengerUpdate) {
      onPassengerUpdate(passengers);
    }
    // setPassengers(paxList);
  }, [passengers]);
  return (
    <div>
      {passengers.map((pax, index) => (
        <>
          <div className="fs-14 fw-600 mb-4 mt-4">
            {index === 0 ? 'Lead pax' : pax.paxtype}
          </div>
          <Row key={index}>
            <Col lg={3} md={3} sm={3} xs={12}>
              <AppSelect
                label={formattedMessage('title')}
                options={
                  pax.paxtype === 'Child' ? CHILD_TITLE_OPTIONS : TITLE_OPTIONS
                }
                name="title"
                selectedValue={pax.title}
                onSelect={(value, name) =>
                  handleDropDownChange(value, name, index)
                }
                errorText={passengerErrorDict[index]?.title}
              />
            </Col>

            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label={formattedMessage('first_name')}
                name="firstname"
                id="firstname"
                required
                value={pax.firstname}
                onChange={(event) => handleChange(event, index)}
                errorText={passengerErrorDict[index]?.firstname}
              />
            </Col>

            <Col lg={3} md={3} sm={3} xs={12}>
              <AppTextInput
                label={formattedMessage('last_name')}
                name="lastname"
                id="lastname"
                required
                value={pax.lastname}
                onChange={(event) => handleChange(event, index)}
                errorText={passengerErrorDict[index]?.lastname}
              />
            </Col>
          </Row>
        </>
      ))}
    </div>
  );
}

CabsPassengerDetails.propTypes = {
  paxList: PropTypes.array.isRequired,
  defaultTravellerInfo: PropTypes.array.isRequired,
  onPassengerUpdate: PropTypes.func.isRequired,
  passengerErrorDict: PropTypes.object,
};

export default CabsPassengerDetails;
